import React, { ReactElement } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Tab,
  Grid,
  GridColumn,
  GridRow,
} from "@screencloud/screencloud-ui-components";
import { EditorStore } from "../../types";
import { RootState } from "../../reducers";

import { deselectChannel } from "../../actions";

import Share from "../../containers/Share/Share";
import StreamSetup from "../../components/StreamSetup/StreamSetup";

import LiveStreamLogo from "../../assets/live-stream-logo.svg";
import "./StreamAuthView.scss";

const TITLES = {
  LIVE_VIDEO: "Live Video Setup",
  SHARING_OPTIONS: "Sharing Options",
  INFO: "You can now broadcast live video to this Streaming Channel",
  DESCRIPTION:
    "Copy & paste the info below into Zoom or OBS when setting up a new broadcast.",
  REMINDER: "(Don't forget to add this app to your screen's playlist.)",
  CHOOSE_ANOTHER: "Choose a different Streaming Channel",
  RESTRICTION_MESSAGE:
    "Broadcasts are limited to 3 hours per event. After 3 hours the stream keys will be refreshed and will need to be copied to source platform to continue Broadcast",
};

const StreamAuthView = (): ReactElement<void> => {
  const editor: EditorStore = useSelector((state: RootState) => state.editor);

  const dispatch = useDispatch();

  return (
    <div className="setup-container">
      <div className="stream-name-banner">
        <Grid className="stream-name-banner_outer-grid">
          <GridRow>
            <GridColumn
              className={
                "columnA mobile hidden three wide tablet three wide computer"
              }
            />
            <GridColumn
              className={
                "columnB sixteen wide mobile nine wide tablet nine wide computer"
              }
            >
              <Grid className={"stream-name-banner_grid"}>
                <GridRow verticalAlign="middle" textAlign="left">
                  <GridColumn
                    className={
                      "stream-name-banner_img two wide mobile two wide tablet two wide computer"
                    }
                  >
                    <img
                      className={"stream-name-banner_icon"}
                      src={LiveStreamLogo}
                      alt="Logo"
                    />
                  </GridColumn>
                  <GridColumn
                    className={
                      "stream-name-banner_title fourteen wide mobile fourteen wide tablet fourteen wide computer"
                    }
                  >
                    <span>
                      {editor.channel !== null
                        ? editor.channel.name
                        : "unknown"}
                    </span>
                  </GridColumn>
                </GridRow>
              </Grid>
            </GridColumn>
            <GridColumn
              className={
                "stream-name-banner_button sixteen wide mobile four wide tablet four wide computer"
              }
            >
              <div className="choose-another-stream">
                <Button
                  outline="true"
                  onClick={() => dispatch(deselectChannel(null))}
                >
                  <span>{TITLES.CHOOSE_ANOTHER}</span>
                </Button>
              </div>
            </GridColumn>
          </GridRow>
        </Grid>
      </div>
      <Grid centered className="stream-info-grid">
        <GridRow>
          <GridColumn
            className={
              "sixteen wide mobile nine wide tablet nine wide computer"
            }
          >
            <div className="stream-info-header">{TITLES.INFO}</div>
            <div className="stream-info-copy">{TITLES.DESCRIPTION}</div>
            <div className="stream-info-restrictions">
              {TITLES.RESTRICTION_MESSAGE}
            </div>
            <div className="stream-info-reminder">{TITLES.REMINDER}</div>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn
            className={
              "sixteen wide mobile nine wide tablet nine wide computer"
            }
          >
            <div className="stream-setup">
              <Tab
                className="config"
                menu={{ secondary: true, pointing: true }}
                panes={[
                  {
                    menuItem: TITLES.LIVE_VIDEO,
                    // eslint-disable-next-line react/display-name
                    render: () => {
                      return <StreamSetup stream={editor.channel} />;
                    },
                  },
                  {
                    menuItem: TITLES.SHARING_OPTIONS,
                    // eslint-disable-next-line react/display-name
                    render: () => {
                      return <Share />;
                    },
                  },
                ]}
              />
            </div>
          </GridColumn>
        </GridRow>
      </Grid>
    </div>
  );
};

export default StreamAuthView;
